import React from 'react'
import { FormattedMessage } from 'react-intl'
import addSignage from '../../../assets/icons/signage-plus/add-signage.svg'
import { SIGNAGE_MEDIA } from '../../../utils/constants'

export function SignageZonePanel({ children, ...props }) {
  return (
    <div
      className="signage-dashed-panel w-100 h-100 d-flex flex-column justify-content-center align-items-center"
      style={{ ...props.style }}
      {...props}
    >
      {children}
    </div>
  );
}

export function AddSignageButton({ icon, label, onClick, ...props }) {
  return (
    <button type="button" className="add-signage d-flex justify-content-center" {...props} onClick={onClick}>
      <img src={addSignage} alt="" className="me-2" style={{ verticalAlign: 'middle' }} />
      <span className="d-flex align-items-center" style={{ height: '24px' }}>
        {label}
      </span>
    </button>
  );
}

const zonePanelsConfig = {
  '10': [
    {
      col: 12,
      className: "",
      style: {maxWidth: '100%',overflow: 'hidden', aspectRatio: '16 / 9'},
      panels: [
        {
          zone: SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST,
          panelClassName: "h-100",
          panelStyle: {},
          title: <FormattedMessage id="MAIN_SIGNAGE_CONTENT" />,
          button: <FormattedMessage id="ADD_PLAYLIST" />,
          buttonProps: { 'data-bs-toggle': 'modal', 'data-bs-target': '#addPlaylistModal' },
          replaceButton: <FormattedMessage id="REPLACE_PLAYLIST" defaultMessage="replace playlist" />,
        }
      ]
    }
  ],
  '20': [
    {
      col: 3,
      className: "d-flex flex-column justify-content-center align-items-center",
      style: { flex:"0 0 21%", maxWidth: '21%', overlay: 'hidden' },
      panels: [
        {
          zone: SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1,
          panelClassName: "w-100",
          panelStyle: {height: 'auto', maxHeight: '100%', flexGrow: 1},
          title: <FormattedMessage id="WIDGET_1" defaultMessage="widget 1" />,
          button: <FormattedMessage id="ADD_WIDGET" defaultMessage="add widget" />,
          buttonProps: { 'data-bs-toggle': 'modal', 'data-bs-target': '#widgetsModal' },
          replaceButton: <FormattedMessage id="REPLACE_WIDGET" defaultMessage="replace widget" />,
        }
      ]
    },
    {
      col: 9,
      className: "d-flex",
      style: {minWidth: 'calc(79% - 20px)', width: 'calc(79% - 20px)', height: 'auto', overflow: 'hidden', aspectRatio: '16 / 9',alignItems: 'start'},
      panels: [
        {
          zone: SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST,
          panelClassName: "w-100",
          panelStyle:{ height: "auto",aspectRatio: '16 / 9' },
          title: <FormattedMessage id="MAIN_SIGNAGE_CONTENT" />,
          button: <FormattedMessage id="ADD_PLAYLIST" />,
          buttonProps: { 'data-bs-toggle': 'modal', 'data-bs-target': '#addPlaylistModal' },
          replaceButton: <FormattedMessage id="REPLACE_PLAYLIST" defaultMessage="replace playlist" />,
        }
      ]
    }
  ],
  '31': [
    {
      col: 3,
      className: "d-flex flex-column justify-content-between align-items-stretch",
      style: { gap: 20, flex: "0 0 21%", overflow: 'hidden', maxWidth: '21%' },
      panels: [
        {
          zone: SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1,
          panelClassName: "flex-fill d-flex flex-column justify-content-center",
          panelStyle: {maxHeight: 'calc(50% - 10px)',minHeight: 'calc(50% - 10px)'},
          title: <FormattedMessage id="WIDGET_1" defaultMessage="widget 1" />,
          button: <FormattedMessage id="ADD_WIDGET" defaultMessage="add widget" />,
          buttonProps: { 'data-bs-toggle': 'modal', 'data-bs-target': '#widgetsModal' },
          replaceButton: <FormattedMessage id="REPLACE_WIDGET" defaultMessage="replace widget" />,
        },
        {
          zone: SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET2,
          panelClassName: "flex-fill d-flex flex-column justify-content-center",
          panelStyle: {maxHeight: 'calc(50% - 10px)',minHeight: 'calc(50% - 10px)'},
          title: <FormattedMessage id="WIDGET_2" defaultMessage="widget 2" />,
          button: <FormattedMessage id="ADD_WIDGET" defaultMessage="add widget" />,
          buttonProps: { 'data-bs-toggle': 'modal', 'data-bs-target': '#widgetsModal' },
          replaceButton: <FormattedMessage id="REPLACE_WIDGET" defaultMessage="replace widget" />,
        }
      ]
    },
    {
      col: 9,
      className: "d-flex flex-column align-items-center",
      style: { flex:"0 0 calc(79% - 20px)",  maxWidth: 'calc(79% - 20px)',overflow: 'hidden'},
      panels: [
        {
          zone: SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST,
          panelClassName: "",
          panelStyle: { width: '100%' ,height: "auto", aspectRatio: '16 / 9'},
          title: <FormattedMessage id="MAIN_SIGNAGE_CONTENT" />,
          button: <FormattedMessage id="ADD_PLAYLIST" />,
          buttonProps: { 'data-bs-toggle': 'modal', 'data-bs-target': '#addPlaylistModal' },
          replaceButton: <FormattedMessage id="REPLACE_PLAYLIST" defaultMessage="replace playlist" />,
        }
      ]
    }
  ],
  '32': [
    {
      col: 3,
      className: "d-flex flex-column justify-content-center align-items-center",
      style: { flex: "0 0 21%", overflow: 'hidden', maxWidth: '21%' },
      panels: [
        {
          zone: SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1,
          panelClassName: "h-100",
          panelStyle: { width: '100%',maxHeight: '100%' },
          title: <FormattedMessage id="WIDGET_1" defaultMessage="widget 1" />,
          button: <FormattedMessage id="ADD_WIDGET" defaultMessage="add widget" />,
          buttonProps: { 'data-bs-toggle': 'modal', 'data-bs-target': '#widgetsModal' },
          replaceButton: <FormattedMessage id="REPLACE_WIDGET" defaultMessage="replace widget" />,
        }
      ]
    },
    {
      col: 9,
      className: "d-flex",
      style: { flex: "0 0 calc(79% - 20px)" , maxWidth: 'calc(79% - 20px)',overflow: 'hidden'},
      panels: [
        {
          zone: SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST,
          panelClassName: "",
          panelStyle: { aspectRatio: '16 / 9', width: '100%'},
          title: <FormattedMessage id="MAIN_SIGNAGE_CONTENT" />,
          button: <FormattedMessage id="ADD_PLAYLIST" />,
          buttonProps: { 'data-bs-toggle': 'modal', 'data-bs-target': '#addPlaylistModal' },
          replaceButton: <FormattedMessage id="REPLACE_PLAYLIST" defaultMessage="replace playlist" />,
        }
      ]
    },
    {
      col: 12,
      className: "",
      style: { height: "var(--ticker-text-h)" },
      panels: [
        {
          zone: SIGNAGE_MEDIA.CREATE_SIGNAGE.TICKER,
          panelClassName: "",
          panelStyle: { height: "var(--ticker-text-h)", minHeight: "var(--ticker-text-h)", maxHeight: "var(--ticker-text-h)" },
          title: null,
          button: <FormattedMessage id="ADD_SCROLLING_MESSAGE" />,
          buttonProps: { 'data-bs-toggle': 'modal', 'data-bs-target': '#tickerMessageModal' },
          replaceButton: <FormattedMessage id="REPLACE_TICKER_MESSAGE" />,
        }
      ]
    }
  ],
  '40': [
    {
      col: 3,
      className: "d-flex flex-column justify-content-between align-items-stretch",
      style: {  gap: 20, flex: "1 0 21%", overflow: 'hidden', maxWidth: '21%' },
      panels: [
        {
          zone: SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1,
          panelClassName: "flex-fill d-flex flex-column justify-content-center h-100",
          panelStyle: {maxHeight: 'calc(50% - 10px)',minHeight: 'calc(50% - 10px)'},
          title: <FormattedMessage id="WIDGET_1" defaultMessage="widget 1" />,
          button: <FormattedMessage id="ADD_WIDGET" defaultMessage="add widget" />,
          buttonProps: { 'data-bs-toggle': 'modal', 'data-bs-target': '#widgetsModal' },
          replaceButton: <FormattedMessage id="REPLACE_WIDGET" defaultMessage="replace widget" />,
        },
        {
          zone: SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET2,
          panelClassName: "flex-fill d-flex flex-column justify-content-center h-100",
          panelStyle: {maxHeight: 'calc(50% - 10px)',minHeight: 'calc(50% - 10px)'},
          title: <FormattedMessage id="WIDGET_2" defaultMessage="widget 2" />,
          button: <FormattedMessage id="ADD_WIDGET" defaultMessage="add widget" />,
          buttonProps: { 'data-bs-toggle': 'modal', 'data-bs-target': '#widgetsModal' },
          replaceButton: <FormattedMessage id="REPLACE_WIDGET" defaultMessage="replace widget" />,
        }
      ]
    },
    {
      col: 9,
      className: "d-flex flex-column w-100 align-items-center",
      style: { flex: "1 0 calc(79% - 20px)" , maxWidth: 'calc(79% - 20px)',overflow: 'hidden' },
      panels: [
        {
          zone: SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST,
          panelClassName: "h-100 w-100",
          panelStyle: { height: "auto",aspectRatio: '16 / 9' },
          title: <FormattedMessage id="MAIN_SIGNAGE_CONTENT" />,
          button: <FormattedMessage id="ADD_PLAYLIST" />,
          buttonProps: { 'data-bs-toggle': 'modal', 'data-bs-target': '#addPlaylistModal' },
          replaceButton: <FormattedMessage id="REPLACE_PLAYLIST" defaultMessage="replace playlist" />,
        }
      ]
    },
    {
      col: 12,
      className: "",
      style: { height: "var(--ticker-text-h)" },
      panels: [
        {
          zone: SIGNAGE_MEDIA.CREATE_SIGNAGE.TICKER,
          panelClassName: "",
          panelStyle: { height: "var(--ticker-text-h)", minHeight: "var(--ticker-text-h)", maxHeight: "var(--ticker-text-h)" },
          title: null,
          button: <FormattedMessage id="ADD_SCROLLING_MESSAGE" />,
          buttonProps: { 'data-bs-toggle': 'modal', 'data-bs-target': '#tickerMessageModal' },
          replaceButton: <FormattedMessage id="REPLACE_TICKER_MESSAGE" />,
        }
      ]
    }
  ]
};

export default zonePanelsConfig
